import { HttpService } from "./http.service";

const basePath = "/PredictionModel";
const request = HttpService.handleRequest();

export const PredictionModelService = {
  getAll,
  insert,
  trash
};

async function getAll() {
  return request.get(basePath);
}

async function insert(data) {
  return request.post(`${basePath}/InsertByProc`, data);
}

async function trash(id) {
  return request.delete(`${basePath}/DeleteById/${id}`);
}

export default PredictionModelService;